import React, { useEffect, useState, useLayoutEffect, useImperativeHandle, useContext } from "react";
import { useParams } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import "./SchemedetailsMF.css";

function SchemedetailsMF(props) {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { MFcode } = useParams();
    // console.log(MFCode, "MFCode")
    const [data, setData] = useState([]);
    let getMFCode = props.MFcode;
    let getcompname, getData;
    const { BaseURL } = useContext(URLstateContext);

    useEffect(() => {
        if (getMFCode != '') {
            const getUrl = BaseURL + "GetQuoteDetailsMF";
            fetch(`${getUrl}/${getMFCode}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    // console.log("aaaaaaa", getData);
                })
                .catch((error) => {
                    // console.log("not found the api");
                });
        }
    }, [getMFCode]);

    return (
        <>
            <section className="peer-sc">
                <div className='container table-boxpeerMutual'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h3 className="mainHeadingGroup">Scheme Details</h3>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped table-bordered table-hover">

                                    <thead className='heading'>
                                        <tr>
                                            <th scope="col">AMC Name</th>
                                            <th scope="col">Fund Manager</th>
                                            <th scope="col">Registered Office</th>
                                        </tr>
                                    </thead>
                                    {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                    <tbody>

                                        {data && data.map(
                                            ({ AMCName, FundManager, OfficeAdd1, OfficeAdd2, OfficeAdd3, OfficeTel, OfficeFax, email, AMCWebsite }) => (
                                                <tr className="">
                                                    <td className="text-left">{AMCName}</td>
                                                    <td className="text-left">{FundManager}</td>
                                                    <td className="text-left schm-details">
                                                       <div>
                                                            <label>Address:</label>
                                                            <span>{OfficeAdd1}{OfficeAdd2}{OfficeAdd3}</span><br></br>
                                                            </div>
                                                        <div>
                                                            <label>Tel No.</label>
                                                            <span>{OfficeTel}</span>
                                                            </div>
                                                        <div>
                                                            <label>Fax:</label>
                                                            <span>{OfficeFax}</span>
                                                        </div>
                                                        <div>
                                                            <label>E-mail:</label>
                                                            <span>{email}</span>
                                                        </div>
                                                        <div>
                                                            <label>Website:</label>
                                                            <span>{AMCWebsite}</span>
                                                        </div>
                                                    </td>
                                                </tr>

                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default SchemedetailsMF;
